import React from 'react';
import styled from "styled-components";
import {Link} from "react-router-dom";

const StyledNavItem = styled.li`
  a {
    color: rgb(23, 43, 77);
    &:hover, &:active {
      color: #0288BD;
    }
  }
`

const NavLink = ({path = "/", label = 'Label', onClick = () => {}}) => {
  return (
      <StyledNavItem>
        <Link to={path} onClick={onClick}>{label}</Link>
      </StyledNavItem>
    )
}

export default NavLink;
